/* eslint-disable import/no-cycle */
import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from '@mantine/core';
import AppStack from '../../../../../common/AppStack';

const WsColorSwatch = ({
  value,
  primaryColor,
  secondaryColor,
  disabled,
  isColorDisabled,
  selected,
  onClick,
  size
}) => (
  <Tooltip label={value} withArrow>
    <AppStack
      style={{
        padding: 3,
        borderRadius: 100,
        outline: selected ? '2px solid dodgerblue' : 'none'
      }}
    >
      <AppStack
        onClick={onClick}
        style={{
          width: size || 30,
          height: size || 30,
          borderRadius: 100,
          position: 'relative',
          cursor: !onClick ? 'default' : disabled ? 'not-allowed' : 'pointer',
          overflow: 'hidden',
          outline: 'solid 1px #dee2e6'
        }}
      >
        <AppStack
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: primaryColor,
            clipPath: secondaryColor ? 'polygon(0 0, 100% 0, 0 100%)' : 'none'
          }}
        />

        {secondaryColor && (
          <AppStack
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundColor: secondaryColor,
              clipPath: 'polygon(100% 100%, 100% 0, 0 100%)'
            }}
          />
        )}
        {isColorDisabled && (
          <>
            <AppStack
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(255, 255, 255, 0.6)'
              }}
            />
            <AppStack
              style={{
                position: 'absolute',
                top: '50%',
                left: '-25%',
                width: '150%',
                height: 2,
                backgroundColor: '#e03131',
                transform: 'rotate(45deg)',
                zIndex: 2,
                pointerEvents: 'none'
              }}
            />
          </>
        )}
      </AppStack>
    </AppStack>
  </Tooltip>
);

WsColorSwatch.propTypes = {
  disabled: PropTypes.bool,
  isColorDisabled: PropTypes.bool,
  onClick: PropTypes.func,
  primaryColor: PropTypes.string,
  secondaryColor: PropTypes.string,
  selected: PropTypes.bool,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  value: PropTypes.string
};

export default WsColorSwatch;
